import rht from 'react-hot-toast'
import type { ToastOptions } from 'react-hot-toast'
import styled from 'styled-components'

import { Text } from '../components/text'
import { FOOTER_MIN_HEIGHT } from '../components/footer'

import { Color } from '../theme/color'

export function toast(message: string, log?: any, isFooter?: boolean, options?: ToastOptions) {
  rht.custom(
    <ToastContainer $isFooter={typeof isFooter === 'undefined' || isFooter}>
      <Text size={14} lineHeight={22} color="text_white">
        {message}
      </Text>
    </ToastContainer>,
    {
      id: message,
      position: 'bottom-center',
      duration: options?.duration ?? 2000,
    },
  )
  if (process.env.NODE_ENV === 'development') {
    console.log(log)
  }
}

const ToastContainer = styled.div<{ $isFooter: boolean }>`
  display: flex;
  align-item: center;
  justify-content: center;
  width: 100%;
  margin-bottom: ${({ $isFooter }) => ($isFooter ? FOOTER_MIN_HEIGHT : 16)}px;
  padding: 8px;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.8);
  color: ${Color.text_white};
`
